// force-cleanup-orphan-locks-owned-by-self.ts
//
// Phase 05 (AC-02): second Ctrl-C/SIGTERM forces immediate exit — this is
// the synchronous best-effort cleanup run just before `process.exit(130)`,
// deleting the machine lock and journal lease ONLY when they still record
// THIS process's own pid (never someone else's lock/lease).
import { readFileSync, unlinkSync } from "node:fs";
import { join } from "node:path";

export function forceCleanupOrphanLocksOwnedBySelf(
  machineLockPath: string,
  controlRoot: string,
): void {
  for (const p of [machineLockPath, join(controlRoot, "locks", "journal.lock")]) {
    try {
      if (JSON.parse(readFileSync(p, "utf8")).pid === process.pid) unlinkSync(p);
    } catch {
      // not ours, unreadable, or already gone — leave it for `unlock`.
    }
  }
}
